import { logErrorToDatadog } from './errorLogger';

// Note: Datadog SDK (forwardErrorsToLogs: true) also captures these errors natively.
// These handlers add richer context (screen name, component stack) that the SDK's
// automatic capture does not include, so both are kept intentionally.
export const setupGlobalErrorHandlers = (): void => {
  if (typeof window === 'undefined') return;

  window.onerror = (_message, _source, _lineno, _colno, error) => {
    logErrorToDatadog(error || new Error(String(_message)), null, 'global:window.onerror');
    return false;
  };

  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    logErrorToDatadog(error, null, 'global:unhandledrejection');
  });
};
